export function forceDownload(response) {
    let url = window.URL.createObjectURL(new Blob([response.data]));
    let link = document.createElement('a')
    link.href = url

    const contentDisposition = response.headers['content-disposition'];
    let fileName = 'unknown';
    if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename=\"?([^\"]*)\"?/);
        if (fileNameMatch.length === 2) {
          fileName = fileNameMatch[1];
        }
    }

    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click()
}

export function filePreview(response) {
    let contentType = response.headers['content-type'];
    let blob = new Blob([response.data], {type: contentType});
    let obj = window.URL.createObjectURL(blob);
    return obj;
}

// returns last two paths before the file name
export function filePath(uri){
    const LIM = 40;
    let pathToArray = uri.split('/');
    let preLastTwoPaths = pathToArray.slice(Math.max(pathToArray.length - 3, 1), pathToArray.length - 1);
    let path = `${preLastTwoPaths[0]}/${preLastTwoPaths[1]}/`;
    let minified = path.length > LIM ? path.substring(0,LIM) + '...' : path;
    return minified;
}